import { render, staticRenderFns } from "./payloans.vue?vue&type=template&id=3067a468"
import script from "./payloans.vue?vue&type=script&lang=js"
export * from "./payloans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports